/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Product_Buy_Benefits_Mobile1Inputs */

const vi_sitesettings_product_buy_benefits_mobile1 = /** @type {(inputs: Sitesettings_Product_Buy_Benefits_Mobile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mua thuận tiện (điện thoại)`)
};

/**

* @param {Sitesettings_Product_Buy_Benefits_Mobile1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_product_buy_benefits_mobile1 = /** @type {((inputs?: Sitesettings_Product_Buy_Benefits_Mobile1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Product_Buy_Benefits_Mobile1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_product_buy_benefits_mobile1(inputs)
});
export { sitesettings_product_buy_benefits_mobile1 as "siteSettings_product_buy_benefits_mobile" }